import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({ icon, title, subtitle, actionLabel, actionTo }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
          <i className={`${icon} text-lg`} />
        </span>
        <div className="min-w-0">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 truncate">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 truncate">{subtitle}</p>}
        </div>
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="shrink-0 text-sm text-primary-600 hover:text-primary-800 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}